
import { computed, defineComponent } from 'vue'

export default defineComponent({
    name: "EasyModal",
    emits: ['closeModal'],
    props: {
        isShowModal: {
            type: Boolean
        },
        pageTexts: {
            type: Object,
            required: true
        },
        customClasses: {
            type: String
        }
    },
    setup(_props, { emit }) {
        const showModal = computed(() => _props.isShowModal);
        const closeModal = () => {
            emit('closeModal');
        }

        const fixBody = () => {
            document.body.classList.add("modal-active");
        }

        const unfixBody = () => {
            document.body.classList.remove("modal-active");
        }

        return {
            showModal,
            closeModal,
            fixBody,
            unfixBody
        }
    },
})
